uniform vec3 uBaseColor;
uniform float uSize;
uniform float uTime;
uniform float uStep;
uniform float uStepRange;
uniform float uBaseColorPower;
uniform float uSpeed;

varying vec2 vUv;

float PI = 3.14159265359;
void main() {
  // float opacity = pow(sin((vUv.x * +uTime) * (1. / uSize)), 2.);
  float opacity = sin((vUv.x * PI * (1. / uSize) + uTime * uSpeed)) * 0.5 + 0.5;
  opacity = smoothstep(uStep - uStepRange, uStep + uStepRange, opacity);
  gl_FragColor = vec4(uBaseColor * uBaseColorPower, opacity);
}